import React, { useEffect, useState } from 'react';
import Switch from "react-switch";
import { Form, FormFeedback, Input } from 'reactstrap';
import { Offsymbol, OnSymbol, Operativeroles } from '../../../constants/holcim';
import {
    BaseCustomButton,
    BaseSelectComponent,
    GradientDecorationLine,
    BaseCustomModal,
} from '../../../shared';
import { userTypes } from '../../../constants/holcim';
// Formik
import { useFormik } from "formik";
import * as Yup from "yup";

export const UserRegisterModal = ({
    setShowModal,
    showModal,
    modalClose,
    modalRespInfo,
    isUpdate,
    isAdvisor,
    rowInfo,
    labtypes,
    locations,
    isEditingOwnAccount,
}) => {

    const [active, setActive] = useState(false);
    const [isEnable, setEnable] = useState(false);
    const [lockActive, setLockActive] = useState(false);

    const passworkRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/
    const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

    useEffect(() => {
        if (isUpdate) {
            setActive(rowInfo.recordStatus);
            setLockActive(false);
        } else {
            setActive(true);
            setLockActive(true);
        }
    }, [showModal])

    const formikFormData = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,
        initialValues: {
            name: isUpdate ? rowInfo.name : '',
            surname: isUpdate ? rowInfo.surname : '',
            phone: isUpdate ? rowInfo.phone : '',
            email: isUpdate ? rowInfo.email : '',
            password: '',
            laboratoryType: isUpdate ? rowInfo.laboratoryType?.id ?? '' : '',
            location: isUpdate ? rowInfo.location?.id ?? '' : '',
            userType: isAdvisor ? 'Asesor Técnico' : 'Operativo',
            role: isAdvisor ? 'Asesor Técnico' : isUpdate ? rowInfo.role : '',
            signature: isUpdate ? rowInfo.signature : '',
            address: isUpdate ? rowInfo.address : '',
            isGoogled: isUpdate ? !!rowInfo.isGoogled : false,
        },
        validationSchema: ((isEnable && isUpdate) || (!isUpdate)) ? Yup.object({
            name: Yup.string().required("Ingrese el nombre del usuario"),
            surname: Yup.string().required("Ingrese el appellido del usuario"),
            phone: Yup.string().matches(phoneRegExp, 'Número telefónico inválido').required('El número telefónico es un campo requerido'),
            email: Yup.string().email('Ingrese un correo electrónico válido').required('Ingrese el correo electrónico'),
            password: Yup.string().matches(passworkRegex, 'La contraseña debe incluir al menos 8 caracteres, 1 minúscula, 1 mayúscula y 1 número').required('La contraseña es un campo requerido'),
            laboratoryType: isAdvisor ? Yup.string().nullable() : Yup.string().required("Seleccione tipo de laboratorio"),
            location: isAdvisor ? Yup.string().nullable() : Yup.string().required("Seleccione ubicación"),
            userType: Yup.string().required("Seleccione tipo de usuario"),
            role: Yup.string().required("Seleccione un rol"),
            signature: Yup.string().required("Ingrese firma"),
            address: Yup.string().required("Ingrese dirección"),
        }) : Yup.object({
            name: Yup.string().required("Ingrese el nombre del usuario"),
            surname: Yup.string().required("Ingrese el appellido del usuario"),
            phone: Yup.string().matches(phoneRegExp, 'Número telefónico inválido').required('El nùmero telefónico es un campo requerido'),
            email: Yup.string().email('Ingrese un correo electrónico válido').required('Ingrese el correo electrónico'),
            laboratoryType: isAdvisor ? Yup.string().nullable() : Yup.string().required("Seleccione tipo de laboratorio"),
            location: isAdvisor ? Yup.string().nullable() : Yup.string().required("Seleccione ubicación"),
            userType: Yup.string().required("Seleccione tipo de usuario"),
            role: Yup.string().required("Seleccione un rol"),
            signature: Yup.string().required("Ingrese firma"),
            address: Yup.string().required("Ingrese dirección"),
        })
        ,
        onSubmit: (values, { resetForm }) => {
            const pivot = values
            if (!isEnable) {
                if (isUpdate) {
                    delete pivot.password
                }
            }
            modalRespInfo(pivot, active)
            resetForm()
            setShowModal(false)
            setEnable(false)
        }
    });

    const onClosed = () => {
        formikFormData.resetForm()
        setEnable(false)
        modalClose()
        setShowModal(false)
    }

    const children_form = (
        <>
            <h4 className='text-primary m-0 ps-4'>Registro/Actualización de {isAdvisor ? "Asesores Técnicos" : "Usuarios"}</h4>

            <GradientDecorationLine />

            <Form
                className="form-horizontal mt-3 mb-1"
                onSubmit={(e) => {
                    e.preventDefault();
                    formikFormData.handleSubmit();
                    return false;
                }}
            >
                <div className="mb-3 px-5">
                    <label className='text-primary'>Nombre de Usuario</label>
                    <Input
                        name="name"
                        className="form-control text-primary"
                        placeholder="Nombre"
                        type="text"
                        onChange={formikFormData.handleChange}
                        onBlur={formikFormData.handleBlur}
                        value={formikFormData.values.name || ""}
                        invalid={
                            formikFormData.touched.name && formikFormData.errors.name ? true : false
                        }
                    />
                    {formikFormData.touched.name && formikFormData.errors.name ? (
                        <FormFeedback type="invalid">{formikFormData.errors.name}</FormFeedback>
                    ) : null}
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Apellido</label>
                    <Input
                        name="surname"
                        className="form-control text-primary"
                        placeholder="Apellido"
                        type="text"
                        onChange={formikFormData.handleChange}
                        onBlur={formikFormData.handleBlur}
                        value={formikFormData.values.surname || ""}
                        invalid={
                            formikFormData.touched.surname && formikFormData.errors.surname ? true : false
                        }
                    />
                    {formikFormData.touched.surname && formikFormData.errors.surname ? (
                        <FormFeedback type="invalid">{formikFormData.errors.surname}</FormFeedback>
                    ) : null}
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Correo Electrónico</label>
                    <Input
                        name="email"
                        className="form-control text-primary"
                        placeholder="Correo Electrónico"
                        type="text"
                        onChange={formikFormData.handleChange}
                        onBlur={formikFormData.handleBlur}
                        value={formikFormData.values.email || ""}
                        invalid={
                            formikFormData.touched.email && formikFormData.errors.email ? true : false
                        }
                    />
                    {formikFormData.touched.email && formikFormData.errors.email ? (
                        <FormFeedback type="invalid">{formikFormData.errors.email}</FormFeedback>
                    ) : null}
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Domicilio</label>
                    <Input
                        name="address"
                        className="form-control text-primary"
                        placeholder="Domicilio"
                        type="text"
                        onChange={formikFormData.handleChange}
                        onBlur={formikFormData.handleBlur}
                        value={formikFormData.values.address || ""}
                        invalid={
                            formikFormData.touched.address && formikFormData.errors.address ? true : false
                        }
                    />
                    {formikFormData.touched.address && formikFormData.errors.address ? (
                        <FormFeedback type="invalid">{formikFormData.errors.address}</FormFeedback>
                    ) : null}
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Teléfono</label>
                    <Input
                        name="phone"
                        className="form-control text-primary"
                        placeholder="Teléfono"
                        type="text"
                        onChange={formikFormData.handleChange}
                        onBlur={formikFormData.handleBlur}
                        value={formikFormData.values.phone || ""}
                        invalid={
                            formikFormData.touched.phone && formikFormData.errors.phone ? true : false
                        }
                    />
                    {formikFormData.touched.phone && formikFormData.errors.phone ? (
                        <FormFeedback type="invalid">{formikFormData.errors.phone}</FormFeedback>
                    ) : null}
                </div>
                {
                    isUpdate ?
                        <div>
                            <div className='row px-5 mb-3'>
                                <label className='text-primary'>¿Actualizar contraseña?</label>
                                <Switch
                                    uncheckedIcon={<Offsymbol />}
                                    checkedIcon={<OnSymbol />}
                                    onColor="#38a4f8"
                                    onChange={() => { setEnable(!isEnable) }}
                                    checked={isEnable}
                                />
                            </div>
                            {
                                isEnable ?
                                    <div className="mb-3 px-5">
                                        <label className='text-primary'>Nueva contraseña</label>
                                        <Input
                                            name="password"
                                            value={formikFormData.values.password || ""}
                                            type="password"
                                            placeholder="Ingrese contraseña"
                                            onChange={formikFormData.handleChange}
                                            onBlur={formikFormData.handleBlur}
                                            invalid={
                                                formikFormData.touched.password && formikFormData.errors.password && isUpdate ? true : false
                                            }
                                        />
                                        {formikFormData.touched.password && formikFormData.errors.password ? (
                                            <FormFeedback type="invalid">{formikFormData.errors.password}</FormFeedback>
                                        ) : null}
                                    </div> : null
                            }
                        </div>
                        : !isUpdate ?
                            <div className="mb-3 px-5">
                                <label className='text-primary'>Contraseña</label>
                                <Input
                                    name="password"
                                    value={formikFormData.values.password || ""}
                                    type="password"
                                    placeholder="Ingrese contraseña"
                                    onChange={formikFormData.handleChange}
                                    onBlur={formikFormData.handleBlur}
                                    invalid={
                                        formikFormData.touched.password && formikFormData.errors.password && !isUpdate ? true : false
                                    }
                                />
                                {formikFormData.touched.password && formikFormData.errors.password ? (
                                    <FormFeedback type="invalid">{formikFormData.errors.password}</FormFeedback>
                                ) : null}
                            </div> : null
                }
                <div className="mb-3 px-5">
                    <label className='text-primary'>Tipo de Laboratorio</label>
                    <BaseSelectComponent
                        value={formikFormData.values.laboratoryType}
                        options={labtypes.map((labType) => ({ value: labType.id, label: labType.name }))}
                        onChange={(selectedOption) => {
                            formikFormData.setFieldValue('laboratoryType', selectedOption)
                        }}
                        placeholder='Seleccione tipo de laboratorio'
                        error='Seleccione tipo de laboratorio'
                        touched={formikFormData.touched.laboratoryType && formikFormData.errors.laboratoryType}
                        status={formikFormData.touched.laboratoryType && formikFormData.errors.laboratoryType ? 'error' : ''}
                    />
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Ubicación</label>
                    <BaseSelectComponent
                        value={formikFormData.values.location}
                        options={locations.map((location) => ({ value: location.id, label: location.name }))}
                        onChange={(selectedOption) => {
                            formikFormData.setFieldValue('location', selectedOption)
                        }}
                        placeholder='Seleccione ubicación'
                        error='Seleccione ubicación'
                        touched={formikFormData.touched.location && formikFormData.errors.location}
                        status={formikFormData.touched.location && formikFormData.errors.location ? 'error' : ''}
                    />
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Tipo de Usuario</label>
                    <BaseSelectComponent
                        disabled
                        value={formikFormData.values.userType}
                        options={userTypes.map((userType) => ({ value: userType.value, label: userType.value }))}
                        onChange={(selectedOption) => {
                            formikFormData.setFieldValue('userType', selectedOption)
                        }}
                        placeholder='Seleccione tipo de usuario'
                        error='Seleccione tipo de usuario'
                        touched={formikFormData.touched.userType && formikFormData.errors.userType}
                        status={formikFormData.touched.userType && formikFormData.errors.userType ? 'error' : ''}
                    />
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Roles</label>
                    <BaseSelectComponent
                        disabled={isAdvisor}
                        value={formikFormData.values.role}
                        options={Operativeroles.map((role) => ({ value: role.value, label: role.value }))}
                        onChange={(selectedOption) => {
                            formikFormData.setFieldValue('role', selectedOption)
                        }}
                        placeholder='Seleccione rol'
                        error='Seleccione rol'
                        touched={formikFormData.touched.role && formikFormData.errors.role}
                        status={formikFormData.touched.role && formikFormData.errors.role ? 'error' : ''}
                    />
                </div>
                <div className="mb-3 px-5">
                    <label className='text-primary'>Firma</label>
                    <Input
                        name="signature"
                        className="form-control text-primary"
                        placeholder="Firma"
                        type="text"
                        onChange={formikFormData.handleChange}
                        onBlur={formikFormData.handleBlur}
                        value={formikFormData.values.signature || ""}
                        invalid={
                            formikFormData.touched.signature && formikFormData.errors.signature ? true : false
                        }
                    />
                    {formikFormData.touched.signature && formikFormData.errors.signature ? (
                        <FormFeedback type="invalid">{formikFormData.errors.signature}</FormFeedback>
                    ) : null}
                </div>
                <div className="mt-2 px-5">
                    <div className='text-primary pb-2'>¿Autenticación por Google?</div>
                    <Switch
                        className='me-4'
                        name='isGoogled'
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        onColor="#94C12E"
                        onChange={(value1) => {
                            formikFormData.setFieldValue('isGoogled', value1)
                        }}

                        onBlur={formikFormData.handleBlur}
                        checked={!!formikFormData.values.isGoogled}
                    />
                </div>
                <div className="mt-2 px-5">
                    <div className='text-primary pb-2'>Activo</div>
                    <Switch
                        disabled={lockActive || isEditingOwnAccount}
                        className='me-4'
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        onColor="#94C12E"
                        onChange={() => { setActive(!active) }}
                        checked={active}
                    />
                </div>

                <div className='mt-5'>
                    <GradientDecorationLine />
                    <div className="page-title-box d-flex justify-content-end">
                        <BaseCustomButton
                            outline
                            color="primary"
                            className='rounded-3 me-3'
                            onClick={formikFormData.handleSubmit}
                            icon='mdi mdi-content-save me-1'
                            label='Guardar'
                        />
                        <BaseCustomButton
                            outline
                            color="danger"
                            className='rounded-3'
                            onClick={onClosed}
                            icon='mdi mdi-close-circle-outline me-1'
                            label='Cancelar'
                        />
                    </div>
                </div>
            </Form>
        </>
    );

    return (
        <BaseCustomModal
            isModalOpen={showModal}
            handleCancel={onClosed}
            handleOk={onClosed}
            footer={null}
            children={children_form}
            width={600}
        />
    )

}
